import {
	IChatEventChatMaximizedMessage,
	IChatEventChatMinimizedMessage,
} from '@enuan/chat__utils';
import { IFrameState, frameStateContext } from './context';
import { useIsOpen, usePage } from './hooks';

export type IFrameStateProviderProps = Partial<
	Pick<
		IFrameState,
		| 'isOpen'
		| 'page'
		| 'isStandalone'
		| 'hidePopup'
		| 'isFullscreen'
		| 'isDetached'
	>
> & {
	onMinimize?: (message: IChatEventChatMinimizedMessage) => void;
	onMaximize?: (message: IChatEventChatMaximizedMessage) => void;
};

export const FrameStateProvider = ({
	isOpen: _isOpen,
	page: _page,
	isStandalone = false,
	hidePopup = false,
	isFullscreen = false,
	isDetached = false,
	onMaximize,
	onMinimize,
	children,
}: React.PropsWithChildren<IFrameStateProviderProps>) => {
	const [isOpen, toggleChat] = useIsOpen(
		_isOpen,
		onMinimize,
		onMaximize,
		isStandalone,
	);
	const { page, togglePage, setPage, formData } = usePage(_page);

	return (
		<frameStateContext.Provider
			value={{
				isOpen,
				toggleChat,
				page,
				togglePage,
				setPage,
				isStandalone,
				formData,
				hidePopup,
				isFullscreen: isFullscreen || isDetached,
				isDetached,
			}}
		>
			{children}
		</frameStateContext.Provider>
	);
};
